module.exports = __webpack_public_path__ + "img/mode-continuous.ffe8de3d.png";